import { render } from "./AppViews.vue?vue&type=template&id=26e9f321&ts=true"
import script from "./AppViews.vue?vue&type=script&lang=ts"
export * from "./AppViews.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/ment-test/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__